import React from "react";

import cx from "classnames";

import styles from "./LoadingLine.scss";

// Generates a random line width between 20 and 80
function randomLineWidth(): number {
  return Math.floor(Math.random() * 80) + 20;
}

export type LoadingLineVariant = "default" | "primary";

/**
 * Props for the LoadingLine component
 */
export interface LoadingLineProps {
  /**
   * Width of the element. Default: random width between 80 and 20%
   */
  width?: string;

  /**
   * Height of the element. Default: 1em
   */
  height?: string;
  /**
   * Changes the color of the loading line.
   */
  variant?: LoadingLineVariant;
}

/**
 * Consolidate a bunch of line of random width
 */
export function LoadingLine({
  width = `${randomLineWidth()}%`,
  height = "1em",
  variant = "default",
}: LoadingLineProps): React.ReactElement {
  return (
    <div
      aria-busy="true"
      aria-live="polite"
      data-testid="loading-line"
      className={cx(styles.line, {
        [styles.primary]: variant === "primary",
      })}
      style={{ width, height }}
    />
  );
}
